import Uppy from '@uppy/core'
import XHRUpload from '@uppy/xhr-upload'
import Dashboard from '@uppy/dashboard'
import Bulgarian from '@uppy/locales/lib/bg_BG'

export default class AprilFoolsUpload {
    constructor($root){
        let that    = this;
        this.$root  = $root;

        this.maxVideoSize = 250; //mb
        this.maxPhotoSize = 5; //mb

        this.$title = this.$root.find('[name="af_upload_name"]');
        this.$uppy  = this.$root.find('.af-profile-upload-uppy');
        this.$btn   = this.$root.find('.af-profile-upload-btn');

        this.openTabByDefault();

        const uppy = new Uppy({
            autoProceed: true,
            onBeforeFileAdded: (currentFile, files) => {
                if(!currentFile.type) {
                    uppy.info(`Невалиден файл`, 'error', 500);
                    return false;
                }

                let isVideo = currentFile.type.includes('mp4');
                let maxSize = isVideo ? this.maxVideoSize : this.maxPhotoSize;

                if( currentFile.size > (maxSize*1024*1024) ){
                    uppy.info(`Файлът надвишава разрешения размер`, 'error', 500);
                    return false;
                }
                
                return true;
            },
            restrictions: {
                maxNumberOfFiles: 1,
                minNumberOfFiles: 1,
                allowedFileTypes: [
                    'image/*',
                    '.jpg',
                    '.jpeg',
                    '.png',
                    '.gif',
                    'video/mp4',
                    '.mp4'
                ]
            },
            locale: Bulgarian
        }).use(Dashboard, {
                target: this.$uppy[0],
                proudlyDisplayPoweredByUppy: false,
                inline: true,
                locale: Bulgarian,
                height: 300,
                hideProgressAfterFinish: true
            }).use(XHRUpload, {
                endpoint: this.$uppy.data('xhr') 
            });

        uppy.on('upload-success', (file, response) => { 
            if(response.body.path && response.body.hash){
                that.prepareAjax(response.body.path, response.body.hash);
            }
        });

        uppy.getPlugin('Dashboard').openModal();
    }

    openTabByDefault(){
        let tab = window.location.hash == '#promocodes' ? 'tab-four' : 'tab-five';

        setTimeout(function(){
            jQuery('.profile-sidebar .nav-tabs li').each(function(){
                let $e  = jQuery(this); 
                let $ch = $e.children()
                
                $e.toggleClass('active', $ch.attr('href') == '#' + tab);
                $ch.toggleClass('active', $ch.attr('href') == '#' + tab);
            });

            jQuery('.all-tabs .tab').each(function(){
                let $e  = jQuery(this);
                $e.attr('id') == tab ?
                    $e.show() :
                    $e.hide() ;
            });
        }, 1000);
    }

    prepareAjax(path, hash){
        let that = this;

        this.$btn.removeClass('btn-disabled');
        this.$btn.on('click', function(){
            let title = that.$title.val();
            if( title == '' ){
                alert('Моля, въведете заглавие за вашата смешка!');
                return;
            }

            jQuery.post('/aprilLaughSave', {
                title: title,
                path: path,
                hash: hash
            }, function(data){
                if(data.success){
                    jQuery('.af-upload-success').addClass('active');
                } else {
                    alert('Грешка при прикачването на смешката.');
                }
            }, 'json');
        });
    }
}